module.exports = __webpack_public_path__ + "media/images/history/kojdecky3-6c63936b9855d4f6bd33296460fe4f41.jpg";